import { render, staticRenderFns } from "./BrandMisc.vue?vue&type=template&id=20a6bbb2&"
import script from "./BrandMisc.vue?vue&type=script&lang=js&"
export * from "./BrandMisc.vue?vue&type=script&lang=js&"
import style0 from "./BrandMisc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports